import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import headerSlide from './headerSlice';
import { RootState } from './index';

export const headerActions = headerSlide.actions;

export const toggleNotification = (flag: boolean): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(headerActions.setNotificationOpen(flag));
  };
};

export const toggleProfile = (flag: boolean): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(headerActions.setProfileOpen(flag));
  };
};

export const toggleLanguage = (flag: boolean): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(headerActions.setLanguageOpen(flag));
  };
};
